import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/money/exchangemoney`;

const saveExchangeMoney = async (formData) => {
    return await axios.post(API_URL, formData);
};

const getExchangeMoneys = async () => {
    return await axios.get(API_URL);
};

export default {
    saveExchangeMoney,
    getExchangeMoneys
};
